import { atom } from "jotai";

export const intentSearchKeywordAtom = atom<string>();
